import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";

import helpers from "../../helpers/common";
import servers from "../../models/servers";
import ServerForm from "./ServerForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function ServerEdit(props) {
    const {setShowLoader} = useRootHook()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [serverData, setServerData] = useState([])
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({})

    useEffect(() => {
        if (!searchParams.get('id')) navigate('/servers')
        setShowLoader(true)
        servers.getServer(searchParams.get('id'))
            .then((data) => {
                setShowLoader(false)
                data && setServerData(data)
                data && setFields((prevFields) => {
                    return {...prevFields, name: data.name, id: data.id}
                })
            }).catch(() => setShowLoader(false))
    }, [])

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        if (!servers.FORM_FIELDS.includes(name)) return

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof servers.fieldValidator[name] === 'function'
        && servers.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = servers.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        servers.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/servers')
            }).catch(() => setShowLoader(false))
    }

    if (!serverData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title={`Edit server: ${serverData.name || serverData.id || ''}`} breadcrumbs={[['Dashboard', '/'], ['Servers', '/servers'], ['Edit', `/servers/edit?id=${serverData.id}`]]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <ServerForm serverData={serverData} fields={fields} errors={errors} handleChange={handleChange}
                            handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}